import { Dropdown, IconButton, SvgMoreHoriz, Tooltip } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { COPY_LINK } from 'constants/menuOptions';
import { SHARE_PAGE } from 'constants/menuPages';

import useMenuOptions from 'hooks/useMenuOptions';

import HideDuringDowntime from 'components/hide-during-downtime';

const OverflowMenu = ({ triggerFocusTitle, video, isLoggedIn }) => {
  const options = useMenuOptions({
    item: video,
    assetType: 'video',
    rootFolderId: video.folder_id,
    context: SHARE_PAGE,
    pageType: useSelector(state => state.videos_dashboard.pageType),
    showIcons: true,
    menuProps: {
      triggerFocusTitle,
    },
  });

  if (!options?.length) {
    return null;
  }

  if (options.length === 1) {
    const { title, icon, onClick, disabled } = options[0];

    if (title === COPY_LINK) {
      return null;
    }

    return (
      <IconButton
        altText={title}
        icon={icon}
        onClick={onClick}
        isDisabled={disabled}
      />
    );
  }

  return (
    <HideDuringDowntime>
      <Tooltip content="More actions..." placement="bottomLeft">
        <Dropdown
          options={options}
          trigger={
            <IconButton altText="Toggle actions" icon={<SvgMoreHoriz />} />
          }
          menuPosition="right"
          menuZIndex={isLoggedIn ? 100 : 1001}
        />
      </Tooltip>
    </HideDuringDowntime>
  );
};

export default OverflowMenu;
